export default {"src":"/_next/static/media/icon_nav_dd_roadmap_on.319d17d7.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};